<div class="ap-margin-bottom-2 ap-display-block">
    @if (showEntrepreneurIncome) {
        <ap-radio-group
            [description]="'income.input.incomeType.label' | apKeyOverride: contentKeyMap | apContent"
            [control]="incomeTypeForm.controls.type | apFormControl"
            data-testid="income-type"
        >
            <ap-radio-button
                [label]="'income.input.employment' | apKeyOverride: contentKeyMap | apContent"
                value="employment"
                name="type"
                [formControl]="incomeTypeForm.controls.type | apFormControl"
            >
            </ap-radio-button>
            <ap-radio-button
                [label]="'income.input.entrepreneur' | apKeyOverride: contentKeyMap | apContent"
                value="entrepreneur"
                name="type"
                [formControl]="incomeTypeForm.controls.type | apFormControl"
            >
            </ap-radio-button>
        </ap-radio-group>
    }
    @if (incomeTypeForm.controls.type.value === 'entrepreneur' && showEntrepreneurIncome) {
        <div>
            <ap-entrepreneur-income
                [form]="entrepreneurIncomeForm"
                [numberOfDecimals]="numberOfDecimals"
                [contentKeyMap]="contentKeyMap"
            ></ap-entrepreneur-income>
        </div>
    }
    @if (incomeTypeForm.controls.type.value === 'employment' || !showEntrepreneurIncome) {
        <div>
            <ap-employment-income
                [form]="monthlyIncomeForm"
                [numberOfDecimals]="numberOfDecimals"
                [contentKeyMap]="contentKeyMap"
            ></ap-employment-income>
        </div>
    }
</div>
<ap-button (click)="calculateClicked()" data-testid="calculate-income-button">{{
    'income.input.monthlyIncome.calculate' | apKeyOverride: contentKeyMap | apContent
}}</ap-button>
